import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const SECRET = process.env.REACT_APP_STORAGE_SECRET;

if (!SECRET) {
  // Without a key every secure write silently no-ops, which surfaces as a
  // successful login that bounces straight back to the sign-in page.
  console.error(
    'REACT_APP_STORAGE_SECRET is not set. Authentication cannot be stored and sign-in will not persist. ' +
    'Add it to your .env file and restart the dev server.'
  );
}

const COOKIE_OPTIONS = {
  expires: 1,
  secure: window.location.protocol === 'https:',
  sameSite: 'Strict',
  path: '/',
};

/**
 * Encrypt a value and store it in a cookie.
 * Accepts strings or any JSON-serialisable value.
 */
export const setSecureItem = (key, value) => {
  try {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(stringValue, SECRET).toString();
    Cookies.set(key, encrypted, COOKIE_OPTIONS);
  } catch (error) {
    // Never crash on storage write, but a swallowed failure here breaks the
    // session with no visible symptom, so make it findable.
    console.error(`Failed to write secure storage key "${key}":`, error);
  }
};

/**
 * Read and decrypt a cookie value.
 * Returns the plain string, or null if missing / decryption fails.
 */
export const getSecureItem = (key) => {
  try {
    const encrypted = Cookies.get(key);
    if (!encrypted) return null;
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET);
    return bytes.toString(CryptoJS.enc.Utf8) || null;
  } catch {
    return null;
  }
};

/**
 * Remove a cookie by key.
 */
export const removeSecureItem = (key) => {
  try {
    Cookies.remove(key, { path: '/' });
  } catch {
    // ignore
  }
};

/**
 * Decode the payload of a JWT without verifying the signature.
 * Returns the parsed object, or null if the token is absent / malformed.
 */
export const decodeJwtPayload = (token) => {
  try {
    if (!token) return null;
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};
